module.exports = __webpack_public_path__ + "static/media/9-1.367e9cf1.mp3";